<template>
  <div
    class="custom-menu-wrapper"
    ref="wrapper"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    @mousedown="onMouseDown"
    @mousemove="onMouseMove"
    @mouseup="onMouseUp"
    @mouseleave="onMouseUp"
  >
    <div class="custom-menu" ref="menu">
      <div
        v-for="item in menuList"
        :key="item.name"
        class="menu-item"
        :class="{ active: item.name === active }"
        @click="handleClick(item)"
      >
        {{ item.label }}
        <div v-if="item.name === active && showLine" class="active-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomMenu',
  props: {
    menuList: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    showLine: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      active: this.value,
      touchStartX: 0,
      touchCurrentX: 0,
      scrollLeftStart: 0,
      isTouching: false,
      isMouseDown: false
    }
  },
  watch: {
    value(val) {
      this.active = val
      this.scrollToActive()
    }
  },
  methods: {
    handleClick(item) {
      this.active = item.name
      this.$emit('input', item.name)
      this.$emit('change', item)
      this.scrollToActive()
    },
    scrollToActive() {
      this.$nextTick(() => {
        const menu = this.$refs.menu
        const activeEl = menu.querySelector('.menu-item.active')
        if (!activeEl) return
        const offsetLeft = activeEl.offsetLeft
        const offsetWidth = activeEl.offsetWidth
        const scrollLeft = menu.scrollLeft
        const menuWidth = menu.clientWidth
        if (offsetLeft < scrollLeft) {
          menu.scrollLeft = offsetLeft
        } else if (offsetLeft + offsetWidth > scrollLeft + menuWidth) {
          menu.scrollLeft = offsetLeft + offsetWidth - menuWidth
        }
      })
    },

    /* ====== 移动端 touch 拖拽 ====== */
    onTouchStart(e) {
      this.isTouching = true
      this.touchStartX = e.touches[0].pageX
      this.scrollLeftStart = this.$refs.menu.scrollLeft
    },
    onTouchMove(e) {
      if (!this.isTouching) return
      e.preventDefault()
      this.touchCurrentX = e.touches[0].pageX
      const deltaX = this.touchStartX - this.touchCurrentX
      this.$refs.menu.scrollLeft = this.scrollLeftStart + deltaX
    },
    onTouchEnd() {
      this.isTouching = false
    },

    /* ====== PC 鼠标拖拽 ====== */
    onMouseDown(e) {
      this.isMouseDown = true
      this.touchStartX = e.pageX
      this.scrollLeftStart = this.$refs.menu.scrollLeft
      e.preventDefault()
    },
    onMouseMove(e) {
      if (!this.isMouseDown) return
      const deltaX = this.touchStartX - e.pageX
      this.$refs.menu.scrollLeft = this.scrollLeftStart + deltaX
    },
    onMouseUp() {
      this.isMouseDown = false
    }
  },
  mounted() {
    this.scrollToActive()
  }
}
</script>

<style scoped>
.custom-menu-wrapper {
  margin-left: 10%;
  flex-shrink: 0;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
}

.custom-menu-wrapper:active {
  cursor: grabbing;
}

.custom-menu {
  display: flex;
}

.menu-item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 20px;
  padding: 10px 0px;
  cursor: pointer;
  color: #333;
  font-size: 16px;
  position: relative;
  white-space: nowrap;
  user-select: none;
}

.menu-item:hover {
  color: #ff9900;
}

.menu-item.active {
  color: #ff9900;
}

.active-line {
  position: absolute;
  bottom: 15px;
  left: 0;
  height: 2px;
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;
  background-color: #ff9900;
}

/* 滚动条样式（可选） */
.custom-menu-wrapper::-webkit-scrollbar {
  height: 6px;
}

.custom-menu-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

@media screen and (max-width: 768px) {
  .custom-menu-wrapper {
    margin-left: 0px; /* 靠边站，给内容留空间 */
  }
  .menu-item{
    font-size: 13px;
  }
}
</style>
